/* global $ window */

// Ensure that hidden fonts are shown if TK takes too long to load
window.setTimeout(() => {
    $('html').addClass('wf-delayed')
}, 2000)



/** WEBPACK FOOTER **
 ** ./js/lib/typekit.js
 **/